import ProductFeature1 from "../../../assets/web/images/product-features/product-feature-1.png";
import ProductFeature2 from "../../../assets/web/images/product-features/product-feature-2.png";
import ProductFeature3 from "../../../assets/web/images/product-features/product-feature-3.png";
import ProductFeature4 from "../../../assets/web/images/product-features/product-feature-4.png";
import ProductFeature5 from "../../../assets/web/images/product-features/product-feature-5.png";
import ProductFeature6 from "../../../assets/web/images/product-features/product-feature-6.png";
import FeatureBulletPoint from "./FeatureBulletPoint";
import FeatureItem from "./FeatureItem";

type Feature = {
  title: string;
  imagePosition: "left" | "right";
  imageUrl: string;
  points: string[];
};

const features: Feature[] = [
  {
    title: "Track Attendance & Get Report Smoothly",
    imagePosition: "right",
    imageUrl: ProductFeature1,
    points: [
      "Track all types of employee attendance easily",
      "Days off are scheduled automatically",
      "Location based, remote or office Wi-Fi attendance",
      "Real-time Reports",
    ],
  },
  {
    title: "Apply & Approve Leave At One Click",
    imagePosition: "left",
    imageUrl: ProductFeature2,
    points: [
      "Reduce stress by applying & approving Leave in mobile",
      "Relieve extra tension of prorating leave",
      "Get customized reports",
    ],
  },
  {
    title: "Disburse Salary & Get Pay Report Instantly",
    imagePosition: "right",
    imageUrl: ProductFeature3,
    points: [
      "Reduce chances of mistakes through auto-calculation",
      "Tax calculation has never been this easy",
      "Edit any item anytime",
    ],
  },
  {
    title: "Submit Expenses Just In Few Clicks",
    imagePosition: "left",
    imageUrl: ProductFeature4,
    points: [
      "Reduce employee expenses by tracking efficiently",
      "Multiple cost categories to prepare report",
      "Download & submit anytime",
    ],
  },
  {
    title: "Get Employee Meeting Locations Quickly",
    imagePosition: "right",
    imageUrl: ProductFeature5,
    points: [
      "Track employee meeting location for better transparency",
      "Check visit report instantly",
      "Increase growth team's productivity",
    ],
  },
  {
    title: "Updated Team Report At Once",
    imagePosition: "left",
    imageUrl: ProductFeature6,
    points: [
      "Keep eyes on employee performance",
      "Get report summary in one view",
      "Make instant decisions based on reports",
    ],
  },
];

export default function ProductFeatures() {
  return (
    <section className="bg-[#FFF9F6] py-16">
      {features.map(({ title, imagePosition, imageUrl, points }, index) => (
        <FeatureItem
          key={index}
          title={title}
          imagePosition={imagePosition}
          imageUrl={imageUrl}
        >
          {points.map((point, i) => (
            <FeatureBulletPoint key={i} title={point} />
          ))}
        </FeatureItem>
      ))}
    </section>
  );
}
